import PropTypes from 'prop-types';
import React from 'react';
import { capitalize } from 'lodash';
import SplitLayout from '../../common/layouts/splitLayout';
import StimulusButton from '../../common/stimulus/StimulusButton';
import ThumbButton from '../../common/components/ThumbButton';
import GoButton from '../../common/components/GoButton';
import TextWithHighlight from '../../common/components/TextWithHighlight';
import AudioContainer from '../../common/audio/audioContainer';
import ScreenErrorContainer from '../../common/error/ScreenErrorContainer';
import { BETWEEN_PERCENTAGE_CHARACTER } from '../../constants/regExp';
import { localize, DICTIONARY_KEYS } from '../../common/localization';
import { ARIA_LABELS } from '../../constants/text';


export default class VocabTQVMView extends React.Component {
    /**
     * Function is finding a word that surrounded by '%' symbol in input text,
     * and transform it to the underline one
     * @param text
     * @returns dump component
     */
    static parseStimulusHTML(text) {
        const highlighted = text.match(BETWEEN_PERCENTAGE_CHARACTER)[1];
        const arr = text.split('%').filter((val) => val);
        return (
            <TextWithHighlight
                textDataArr={arr}
                highlightedTemplate={highlighted}
            />
        );
    }

    constructor(props) {
        super(props);
        this.playStimulus = this.playStimulus.bind(this);
        this.handleSelectResponse = this.handleSelectResponse.bind(this);
    }

    componentDidMount() {
        if (!this.props.isDataFetched) {
            this.props.fetchContent();
        } else {
            this.props.narrateScreen(this.props.stimulus.audio);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isDataFetched && this.narrationShouldStart(prevProps)) {
            this.props.narrateScreen(this.props.stimulus.audio);
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    getStimulusArea() {
        if (this.props.isDataFetched) {
            return (
                <div>
                    <StimulusButton
                        isDisabled={this.props.isScreenGreyedOut}
                        styles="stimulus-top"
                        isPlaying={this.props.isStimulusPlaying}
                        onClick={this.playStimulus} />
                    {VocabTQVMView.parseStimulusHTML(this.props.stimulus.text)}
                </div>
            );
        }
        return null;
    }

    getResponsesArea() {
        if (this.props.isDataFetched) {
            return (
                <div className="horizontal-answer-buttons">
                    {this.props.possibleResponses.map((item, index) => (
                        <ThumbButton
                            isDisabled={this.props.isScreenGreyedOut}
                            text={localize(capitalize(item.text))}
                            key={item.id}
                            onClick={this.handleSelectResponse(index)}
                            selected={this.props.selectedResponse === index} />
                    ))}
                </div>
            );
        }
        return null;
    }

    handleSelectResponse(response) {
        return () => {
            this.props.selectResponse(response);
        };
    }

    handleOnNext() {
        return () => {
            this.props.onNext(this.props.selectedResponse);
        };
    }

    playStimulus() {
        this.props.playStimulus(this.props.stimulus.audio);
    }

    narrationShouldStart(prevProps) {
        const isReady = this.props.isDataFetched;
        const shouldStartNarrate = (
            prevProps.isDataFetched !== this.props.isDataFetched
            || prevProps.questionIndex !== this.props.questionIndex
        );
        return isReady && shouldStartNarrate;
    }

    render() {
        return (
            <SplitLayout
                class="flm-lightning"
                upperElement={this.getStimulusArea()}
                lowerElement={this.getResponsesArea()}
                isScreenBlocked={this.props.isScreenBlocked}
                isGreyedOut={this.props.isScreenGreyedOut}>
                <AudioContainer />
                <ScreenErrorContainer onRetry={this.handleOnNext()} />
                {this.props.isNextButtonActive
                    && (
                        <GoButton
                            text={localize(DICTIONARY_KEYS.OK)}
                            onClick={this.handleOnNext()}
                            isEnabled={!this.props.isScreenBlocked}
                            ariaLabel={ARIA_LABELS.GO_TO_NEXT_STEP}
                        />
                    )}
            </SplitLayout>
        );
    }
}

VocabTQVMView.propTypes = {
    fetchContent: PropTypes.func,
    narrateScreen: PropTypes.func,
    onNext: PropTypes.func,
    cleanup: PropTypes.func,
    isDataFetched: PropTypes.bool,
    isScreenBlocked: PropTypes.bool,
    isScreenGreyedOut: PropTypes.bool,
    isNextButtonActive: PropTypes.bool,
    stimulus: PropTypes.object,
    isStimulusPlaying: PropTypes.bool,
    selectResponse: PropTypes.func,
    playStimulus: PropTypes.func,
    questionIndex: PropTypes.number,
    selectedResponse: PropTypes.number,
    possibleResponses: PropTypes.array,
};

VocabTQVMView.defaultProps = {
    isDataFetched: false,
    isScreenBlocked: false,
    isScreenGreyedOut: false,
    isNextButtonActive: false,
    stimulus: undefined,
    selectedResponse: undefined,
    questionIndex: undefined,
    isStimulusPlaying: false,
    possibleResponses: [],
    fetchContent: () => { },
    selectResponse: () => { },
    playStimulus: () => { },
    narrateScreen: () => { },
    onNext: () => { },
    cleanup: () => { },
};
